import { AgGridReactProps } from 'ag-grid-react';
import AgGridReact from 'ui/AgGridReact/AgGridReact';
import React, { useCallback, useEffect, useRef } from 'react';
import {
    ExcelExportConfig,
    registerGridApi,
    unregisterGrid,
    useGridApiContext,
} from 'routes/BudgetModule/contexts/GridApiContext';
import { ExcelExportParams, GridReadyEvent } from 'ag-grid-community';

export default function AgGridReactExposingApi(
    props: AgGridReactProps & {
        excelExport?: ExcelExportConfig;
        className?: string;
        children?: React.ReactNode;
        exportOption?: ExcelExportParams;
    },
): React.ReactElement {
    const { excelExport, onGridReady: onGridReadyProps, exportOption } = props;

    const componentWillUnmount = useRef(false);

    // ----------- USED TO KEEP TRACK OF GRIDAPI FROM CONTEXT ------------//
    const gridsContext = useGridApiContext();
    const onGridReady = useCallback(
        (params: GridReadyEvent) => {
            if (onGridReadyProps !== undefined) {
                onGridReadyProps(params);
            }
            if (excelExport !== undefined)
                registerGridApi(gridsContext, excelExport.fileName, {
                    exportOptions: exportOption || {},
                    sheetName: excelExport.sheetName,
                    grid: params.api,
                });
        },
        [gridsContext, excelExport, onGridReadyProps, exportOption],
    );
    // -------------------------------------------------------------------//

    // ----------------- cleanup on unmount pattern ----------------------//
    useEffect(
        () => () => {
            componentWillUnmount.current = true;
        },
        [],
    );

    useEffect(
        () => () => {
            if (componentWillUnmount.current && excelExport !== undefined) {
                componentWillUnmount.current = false;
                unregisterGrid(gridsContext, excelExport);
            }
        },
        [JSON.stringify(gridsContext), JSON.stringify(excelExport)],
    );
    // -------------------------------------------------------------------//

    return <AgGridReact {...props} onGridReady={onGridReady} />;
}
